import { render } from "./form-floating-labels.vue?vue&type=template&id=7dc5eeb4"
import script from "./form-floating-labels.vue?vue&type=script&lang=js"
export * from "./form-floating-labels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__